module.exports = __webpack_public_path__ + "static/img/8-4.766842b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/8-4.png
// module id = /ZHQ
// module chunks = 0